var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 19.5C2.69771 19.5 2.25 19.0523 2.25 18.5V10C2.25 9.44772 2.69772 9 3.25 9H8.22484L10.265 1.48791C10.3833 1.05234 10.7829 0.733219 11.2259 0.819375C12.8265 1.13063 13.4528 2.44031 13.4528 3.75V7.5C13.4528 7.5 18.6808 7.5 20.4733 7.5C21.2948 7.5 21.8176 8.4 21.7429 9.225L20.6973 18.225C20.6226 18.975 19.9505 19.5 19.2036 19.5H3.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9215 13.5H17.9341",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9215 16.5H17.9341",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6684 10.5H17.9341",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76546 12.5303C6.05712 12.2374 6.05712 11.7626 5.76546 11.4697C5.47379 11.1768 5.00092 11.1768 4.70925 11.4697C4.41759 11.7626 4.41759 12.2374 4.70925 12.5303C5.00092 12.8232 5.47379 12.8232 5.76546 12.5303Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22461 9V19.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.7b9a80cd.svg";
export { ForwardRef as ReactComponent };